import { useEffect, useState, useMemo } from "react";
import CookiesServices from "../../services/CookiesService";

const useLeaderDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const cookiesServices = useMemo(() => new CookiesServices(), []);

  const accessToken = cookiesServices.get("AccessToken");
  const headers = cookiesServices.getHeaders();

  const handleError = (status) => {
    if (status === 401) {
      setFeedback({
        message: "Unauthorized. Please login again.",
        type: "error",
      });
      cookiesServices.clearLogin();
      window.location.href = process.env.REACT_APP_LOGIN_URL;
    } else if (status === 500) {
      setFeedback({
        message: "Internal Server Error. Please try again later.",
        type: "error",
      });
    } else {
      setFeedback({
        message: `Request failed (Status: ${status}).`,
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (!accessToken) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(cookiesServices.toUrl('v1', `/leader_dashboard`), {
          method: 'GET',
          headers,
        });

        if (!res.ok) {
          setError(`Error: ${res.status}`);
          handleError(res.status);
          return;
        }

        const result = await res.json();

        setData(result?.data || null);

      } catch (err) {
        console.error("Fetch error:", err);
        setError(err);

        setFeedback({
          message: "Network error. Please check your connection.",
          type: "error",
        });

      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken]); 

  return {
    data,
    loading,
    error,
    feedback,
  };
};

export default useLeaderDashboard;